module.exports = __webpack_public_path__ + "img/shark_helmet_008.13a75fbc.png";